/**
 * Session expiry event handling
 */
export const SESSION_EXPIRED_EVENT = 'ytest-session-expired';
/**
 * Subscribe to session expiry events.
 *
 * @param callback - Function to call when session expires
 * @returns Cleanup function to unsubscribe
 */
export const onSessionExpired = (callback) => {
    window.addEventListener(SESSION_EXPIRED_EVENT, callback);
    return () => window.removeEventListener(SESSION_EXPIRED_EVENT, callback);
};
/**
 * Dispatch a session expired event.
 */
export const dispatchSessionExpired = () => {
    window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
};
//# sourceMappingURL=events.js.map